import React from 'react';
import IconButton, { IconButtonProps } from '@components/buttons/IconButton';

const EditButton: React.FC<IconButtonProps> = (props) => (
  <IconButton {...props} icon="fa-edit" style={{ position: 'relative', top: '1px' }} />
);

export default EditButton;
